var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"w-full",attrs:{"id":"map"}},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"450","loading":"lazy","allowfullscreen":"","src":"https://www.google.com/maps/embed/v1/place?q=50.9678937%2C%203.3321391&key=AIzaSyCAm0jWckf_LC8MNwq5dL_Sc3TMSzx1984"}})])
}]

export { render, staticRenderFns }